import "number-flow";
import './stats.css';

const initializeNumberFlow = (flow) => {
  if (!flow) return;

  const useGrouping = flow.dataset.useGrouping === "1";

  flow.transformTiming = {
    duration: 1000,
    easing: "ease-out",
  };

  flow.opacityTiming = {
    duration: 1000,
    easing: "ease-out",
  };

  flow.addEventListener("mousedown", (event) => {
    if (event.detail > 1) {
      event.preventDefault();
    }
  });

  flow.format = { useGrouping: useGrouping };
  flow.update(0);
};

const runCounter = (flow) => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  flow.update(flow.dataset.end);
};

document.querySelectorAll(".element-stats").forEach((el) => {
  const staticStatsWrapper = el.querySelector(".static-stats-wrapper");

  if (staticStatsWrapper) {
    const counters = document.querySelectorAll("number-flow[data-counter]");

    counters.forEach((flow) => {
      initializeNumberFlow(flow);

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            runCounter(flow);
            observer.unobserve(flow);
          }
        });
      },
      {
        rootMargin: "0px 0px -25% 0px",
      });

      observer.observe(flow);
    });
  }
});
